import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import {
  auditResultsClear,
  auditResultsFetchAuditorAssets,
  auditResultsFetchIncidentsComparison,
  auditResultsSaveAssetAudit,
} from '../../../actions/auditResultsActions';
import {
  getAuditResultsAppliedAuditorAssetId,
  getAuditResultsIsCompletedAudit,
} from '../../../reducers/assetAudit/auditResults';
import AuditResultsFilters from './AuditResultsFilters';
import AuditResultsTable from './AuditResultsTable';

import './auditResults.less';

const AuditResults = ({
  appliedAuditorAssetId,
  auditResultsClear,
  auditResultsFetchAuditorAssets,
  auditResultsFetchIncidentsComparison,
  auditResultsSaveAssetAudit,
  isAuditResultsCompleted,
}) => {
  useEffect(() => {
    auditResultsFetchAuditorAssets();
  }, [auditResultsFetchAuditorAssets]);

  useEffect(() => {
    return () => {
      auditResultsClear();
    };
  }, [auditResultsClear]);

  useEffect(() => {
    const mustFetch =
      isAuditResultsCompleted != null && appliedAuditorAssetId != null;

    if (mustFetch && isAuditResultsCompleted) {
      auditResultsFetchIncidentsComparison({
        auditAssetId: appliedAuditorAssetId,
      });
    }
    if (mustFetch && !isAuditResultsCompleted) {
      auditResultsSaveAssetAudit({ auditAssetId: appliedAuditorAssetId });
    }
  }, [
    appliedAuditorAssetId,
    auditResultsFetchIncidentsComparison,
    auditResultsSaveAssetAudit,
    isAuditResultsCompleted,
  ]);

  return (
    <>
      <AuditResultsFilters />
      <AuditResultsTable />
    </>
  );
};

const mapStateToProps = state => ({
  appliedAuditorAssetId: getAuditResultsAppliedAuditorAssetId(state),
  isAuditResultsCompleted: getAuditResultsIsCompletedAudit(state),
});

export default connect(mapStateToProps, {
  auditResultsClear,
  auditResultsFetchAuditorAssets,
  auditResultsFetchIncidentsComparison,
  auditResultsSaveAssetAudit,
})(AuditResults);
